import PlaceHolderImage from './PlaceHolderImage.jpg'

import RiccardoImage from './Image1.png'
import Sequential_approach from './Sequential_approach.jpg'
import green_facades from './green_facades.jpg'
import green_facades_framework from './green_facades_framework.jpg'
import sensors from './Sensors.png'
import setpoints_1 from './setpoints_1.png'
import setpoints_2 from './setpoints_2.jpg'

const ProjectsPageData = [
    {
        "date": "2024 - Current",
        "location": "Singapore",
        "title": "AI-driven frameworks for Building Performance Design",
        "subtitle": "Singapore - ETH Centre, National University of Singapore (NUS)",
        "about": "The research develops frameworks for multi-criteria decision marking and quick design explorations in buiding performance design",
        "role": "Role: Project Leader",
        "collaboration": "In Collaboration with: Dr. Alberto Costa, Senior Researcher at Singapore-ETH Centre, Prof. Rudi Stouffs, Assoc. Professor at NUS, Prof. Clayton Miller, Assoc. Professor at NUS.",
        "data": [
            { 'text': 'This page will be updated once more info become available' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
            { 'text': 'In progress' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
        ]
    },
    {
        "date": "2024 - Current",
        "location": "Singapore",
        "title": "Problem decomposition approaches in Building Design",
        "subtitle": "Concordia University (Canada), National University of Singapore (NUS), Singapore-ETH Centre",
        "about": "The research investigates the application of decomposition approaches in building design to reduce problem complexity",
        "role": "Role: Collaborator",
        "collaboration": "In Collaboration with: Nima Bonyadi, PhD Research Assistant at Concordia University",
        "data": [
            { 'text': 'This page will be updated once more info become available' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
            { 'text': 'In progress' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
        ]
    },
    {
        "date": "2024 - Current",
        "location": "Singapore",
        "title": "The role of Archetypes in Urban Building Energy Modelling",
        "subtitle": "Singapore - ETH Centre, National University of Singapore (NUS)",
        "about": "The research improves accuracy and detail of conventional archetypes for urban performance simulation studies ",
        "role": "Role: Project Lead",
        "collaboration": "In Collaboration with: Wanyu Pei, PhD student at NUS and Researcher at Singapore-ETH Centre",
        "data": [
            { 'text': 'This page will be updated once more info become available' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
            { 'text': 'In progress' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
        ]
    },
    {
        "date": "2024 - Current",
        "location": "Singapore",
        "title": "The impact of thermal inertia in mitigating energy disruptions",
        "subtitle": "Singapore - ETH Centre, National University of Singapore (NUS)",
        "about": "The research investigates the potential of building thermal mass to mitigate urban energy disruptions",
        "role": "Role: Collaborator",
        "collaboration": "In Collaboration with: Andrea Bartolini, Postdoctoral Researcher at Singapore-ETH Centre",
        "data": [
            { 'text': 'This page will be updated once more info become available' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
            { 'text': 'In progress' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
        ]
    },
    {
        "date": "2024 - Current",
        "location": "Singapore",
        "title": "Whole life carbon assessment of urban building stock",
        "subtitle": "Singapore - ETH Centre, National University of Singapore (NUS)",
        "about": "The research proposes a framework for conducting city-scale WLCA, integrating both embodied and operational carbon assessments to evaluate the circularity potential of urban building stock",
        "role": "Role: Collaborator",
        "collaboration": "In Collaboration with: Pradeep Alva, PhD student at NUS and Researcher at Singapore-ETH Centre",
        "data": [
            { 'text': 'This page will be updated once more info become available' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
            { 'text': 'In progress' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
        ]
    },
    {
        "date": "2024 - 2025",
        "location": "Singapore",
        "title": "AI-driven frameworks for urban environments ",
        "subtitle": "Singapore - ETH Centre, National University of Singapore (NUS)",
        "about": "The research develops AI-based physics-informed frameworks for urban environments.",
        "role": "Role: Collaborator",
        "collaboration": "In Collaboration with: Pegah Eshraghi, PhD student at Shahid Beheshti University",
        "data": [
            { 'text': 'This research project develops a unified, data-driven methodology to support climate-responsive and human-centered urban design through advanced machine learning and explainable AI. The work addresses a critical gap in urban analytics: while cities generate vast spatial data, planners still lack fast, interpreably predictive tools that translate morphology into actionable design guidance. The project therefore focuses on building scalable AI frameworks that both <b>predict urban performance </b> and <b>explain the underlying drivers</b>, enabling evidence-based decision-making from the early planning stage.' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
            { 'text': 'In progress' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
        ]
    },
    {
        "date": "2023 - 2024",
        "location": "Singapore",
        "title": "Exploring novel cooling technologies for building façades",
        "subtitle": "National University of Singapore (NUS)",
        "about": "The research provides a framework for the synergistic integration of vertical greenery systems (VGS), heat-reflective paints, and façade shading systems.",
        "role": "Role: Collaborator",
        "collaboration": "In Collaboration with: Iqbal Shah, PhD student at NUS",
        "data": [
            { 'text': 'The escalating effects of global warming, driven in part by anthropogenic activities, amplify the challenges posed by climate change. This, in turn, exacerbates the urban heat island (UHI) phenomenon, where metropolitan areas experience significantly warmer temperatures than their rural surroundings. This vicious cycle not only places additional strain on urban infrastructure, but also intensifies energy demands.' },
            { 'text': 'Delving into the synergistic potential of various façade technologies, such as shading systems, heat-reflective paints, and vertical greenery systems to pioneer innovative façade cooling solutions, leading to innovative cooling solutions that enhance energy efficiency and fortify urban resilience.' },
            { 'image': green_facades },
            { 'text': '- Shading on opaque facades alone could reduce cooling loads by 8–28 %.' },
            { 'text': '- Cool paints on opaque facades alone could reduce cooling loads by 10–35 %.' },
            { 'text': '- Combined use of shading and cool paint further reduces cooling loads by 10–40 %.' },
            { 'text': '- Optimal performance needs a balanced mix of shading and paint for specific climates.' },
            { 'image': green_facades_framework },
        ]
    },
    {
        "date": "2023 - 2024",
        "location": "Singapore",
        "title": "Human-centric Indoor Environmental Quality (IEQ) sensing",
        "subtitle": "National University of Singapore (NUS)",
        "about": "The research explores optimal positioning of IEQ sensing devices from an occupant-centric perspective in office settings, aiming to identify sensor placements that most accurately reflect the environmental conditions experienced by occupants.",
        "role": "Role: Project Leader",
        "data": [
            { 'text': 'As smart buildings become more prevalent, there has been an increasing interest in understanding building occupants’ needs and preferences. Since occupant satisfaction is related to the indoor environmental quality (IEQ) of buildings, it is crucial to ensure that the indoor environment is comfortable, healthy, and conducive to the occupants’ well-being.' },
            { 'text': 'This research explores optimal positioning of IEQ sensing devices from an occupant-centric perspective in office settings, aiming to identify sensor placements that most accurately reflect the environmental conditions experienced by occupants.' },
            { 'image': sensors },
            { 'text': 'In progress ' },
            { 'text': 'In progress ' },
            { 'image': PlaceHolderImage },
        ]
    },
    {
        "date": "2023 - 2024",
        "location": "Singapore",
        "title": "Optimizing HVAC temperature setpoints for energy efficiency",
        "subtitle": "National University of Singapore (NUS)",
        "about": "The research evaluates the energy-saving potential of dynamically adjusting room temperature setpoints and setbacks of HVAC systems based on varying outdoor weather and indoor occupancy conditions.",
        "role": "Role: Project Leader",
        "data": [
            { 'text': 'HVAC systems often operate based on fixed schedules that do not match actual building occupancy. This is further amplified by the growing workplace flexibility and remote working trends triggered by the COVID-19 pandemic. With more flexible working hours, unoccupied periods might increase and occupancy rates might drop. ' },
            { 'text': 'This research evaluates the energy-saving potential of dynamically adjusting room temperature setpoints and setbacks of HVAC systems based on varying outdoor weather and indoor occupancy conditions' },
            { 'image': setpoints_1 },
            { 'text': ' - Fixed setpoint achieves 5.48% energy reduction due to lower occupant heat loads.' },
            { 'text': ' - Additional 11.80% energy savings are obtained from incorporating fixed setbacks.' },
            { 'text': ' - Optimal selection of setpoint and setback provides additional 34-38% energy savings.' },
            { 'text': ' - Below 5°C and above 32°C, lowest and highest setpoint is optimal, respectively.' },
            { 'image': setpoints_2 },
        ]
    },
    {
        "date": "2019 - 2022",
        "location": "Loughborough, United Kingdom",
        "title": "The sequential design optimization of building performance",
        "subtitle": "Loughborough University",
        "about": "The research proposes a sequential approach for multi-objective design optimization of building geometry, fabric, HVAC system and controls, advancing performance-based building design. It evaluates its effectiveness, reliability, and efficiency.",
        "role": "Role: Project Leader",
        "collaboration": "In Collaboration with: Prof. Jonathan Wright, Loughborough University, and Dr. Bianca Howard, Columbia University.",
        "data": [
            { 'text': 'Performance-based building design integrates architectural elements, HVAC systems, and operational controls, requiring collaboration among diverse stakeholders. This process is complex due to multidisciplinary interactions, conflicting objectives, and numerous constraints, necessitating the evaluation of many design options.' },
            { 'text': 'This research introduces a sequential approach to multi-objective design optimization of building geometry, fabric, HVAC systems, and controls, aimed at advancing performance-based building design. Unlike conventional methods that optimize all variables simultaneously, this approach sequentially integrates building elements, leveraging their interdependencies. Each stage identifies and passes Pareto-optimal solutions to the next, discarding sub-optimal ones. ' },
            { 'image': Sequential_approach },
            { 'text': 'The proposed two-stage, field-grouped sequential search: consistently identified the same Pareto-optimal solutions as a full factorial search across different problem scales, demonstrating 100% reliability and effectiveness. This approach achieved a 91.2% reduction in function evaluations compared to a full factorial search, highlighting its computational efficiency. Furthermore, in comparison with the widely used NSGA-II algorithm, the sequential approach outperformed in identifying global optima.' },
            { 'text': '- Consistently identified the same Pareto-optimal solutions as a full factorial search across different problem scales, demonstrating 100% reliability and effectiveness'} ,
            { 'text': '- Achieved a 91.2% reduction in function evaluations compared to a full factorial search, highlighting its computational efficiency.' },
            { 'text': '- In comparison with the widely used NSGA-II algorithm, the sequential approach outperformed in identifying global optima.' },
            { 'image': PlaceHolderImage },
        ]
    },
    {
        "date": " 2017 - 2018",
        "location": "Singapore",
        "title": "Comparing laboratory and field studies of occupant lighting experience",
        "subtitle": "Singapore University of Technology and Design (SUTD)",
        "about": "The research investigates if laboratory conclusions related to visual discomfort and lighting quality are applicable to real building conditions. This is achieved by comparing 40 laboratory post-occupancy evaluation responses to 40 field responses in actual office workspaces in Singapore.",
        "role": "Role: Collaborator",
        "collaboration": "In Collaboration with: Dr. J. Alstan Jakubiec, Assist. Professor at Toronto University.",
        "data": [
            { 'text': 'This page will be updated once more info become available' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
            { 'text': 'In progress' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
        ]
    },
    {
        "date": "2017 - 2018",
        "location": "Singapore",
        "title": "Subjective and measured evidence for residential lighting metrics in the tropics",
        "subtitle": "Singapore University of Technology and Design (SUTD)",
        "about": "The research presents a comprehensive study methodology to craft statistically-valid subjective models based on predictive lighting simulation data. This is done by comparing measured and simulated lighting levels in 17 residential housing units in Singapore against the subjective opinions of 35 participants who reside in the units.",
        "role": "Role: Collaborator",
        "collaboration": "In Collaboration with: Dr. J. Alstan Jakubiec, Assist. Professor at Toronto University.",
        "data": [
            { 'text': 'This page will be updated once more info become available' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
            { 'text': 'In progress' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
        ]
    },
    {
        "date": "2017 - 2018",
        "location": "Singapore",
        "title": "Radiant Cooling Systems in the Tropics",
        "subtitle": "Singapore University of Technology and Design (SUTD)",
        "about": "The research aims to support early-design decisions when integrating radiant cooling systems in architectural design. It identifies key design parameters influencing energy consumption, system operation, and thermal comfort in the tropics, providing guidelines for focusing design efforts on impactful variables.",
        "role": "Role: Project Leader",
        "collaboration": "In Collaboration with: Dr. J. Alstan Jakubiec, Assist. Professor at Toronto University",
        "data": [
            { 'text': 'Given the strong influence that architectural design has on radiant systems design, it is necessary to consider their installation from the beginning of the design process, integrated and balanced with the proposed formal design features, internal loads, and external loads throughout the conceptual design phases.' },
            { 'text': 'This research aims to support early-design decisions and simplify the design scenario in order to focus a proportionate amount of design effort on the most influential design variables when integrating radiant cooling systems in the architectural design related to energy consumption, thermal comfort and system operation in the tropics using a sensitivity analysis approach' },
            { 'image': PlaceHolderImage },
            { 'text': '- Radiant cooling systems require different early-design phase considerations than conventional air-based cooling systems' },
            { 'text': '- All three radiant system typologies, if coupled with efficient operational strategies and a complimentary set of design variables, ensure high multi-objective building performance' },
            { 'image': PlaceHolderImage },
        ]
    },
    {
        "date": "2017 - 2018",
        "location": "Singapore",
        "title": "Sustainable Futures: Cooling",
        "subtitle": "Singapore University of Technology and Design (SUTD)",
        "about": "The project investigates human behaviors through long-term observational field studies in commercial and residential spaces, analyzing air-conditioning, window shading, and lighting use. The findings inform predictive models and influence building design decisions.",
        "role": "Role: Collaborator",
        "collaboration": "In Collaboration with: Dr. J. Alstan Jakubiec, Assist. Professor at Toronto University",
        "data": [
            { 'text': 'This page will be updated once more info become available' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
            { 'text': 'In progress' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
        ]
    },
    {
        "date": "2016",
        "location": "California, United States",
        "title": "Optimizing Radiant Systems for Energy Efficiency and Comfort",
        "subtitle": "University of California, Berkeley (UC Berkeley) - Center for the Built Environment",
        "about": "This project improved the understanding of radiant heating and cooling systems, developing guidelines, tools, and resources for system designers. It also contributed to a database of over 400 commercial buildings globally, displayed on an <a href='http://bit.ly/RadiantBuildingsCBEv2' target='_blank'>online interactive map</a>.",
        "role": "Role: Collaborator",
        "collaboration": "In Collaboration with: Fred Bauman, PE",
        "data": [
            { 'text': 'This page will be updated once more info become available' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
            { 'text': 'In progress' },
            { 'text': 'In progress' },
            { 'image': PlaceHolderImage },
        ]
    }
]

ProjectsPageData.forEach(project => {
    project.data.push({ ProjectTitle: project.title });
});

export default ProjectsPageData
